import { TFunction } from "i18next";
import { CustomDate } from "@/types/schemas/person";

export const validationsFVE = (t: TFunction<"validations">) => {
  return {
    fveBrand: (value: string | null) => !value && t("required"),
    fveDate: (value: CustomDate | null) => !value && t("required"),
    fveNumber: (value: string | null) => (!value ? t("required") : value.length > 50 ? t("invalidFVENumber") : null),
    fveInstallation: (value: string | null) => value === null && t("required"),
  };
};
